export default {
  path: '/app',
  component: () => import('@/components/router-entry/common/new-index.vue'),
  name: 'new-version-index',
  children: [
    {
      path: 'my-bluetooth',
      name: 'myBluetooth',
      component: () => import('@/pages/app/my-bluetooth/index.vue'),
      meta: {
        title: '智能蓝牙设备',
        dynamicBgColor: '#f7f8fa'
      }
    },
    {
      path: 'qca-chat',
      name: 'qcaChat',
      component: () => import('@/pages/app/qca-chat/index.vue'),
      children: [
        {
          path: 'view-detail',
          name: 'qcaChatViewDetail',
          component: () => import('@/pages/app/qca-chat/view-detail.vue'),
          meta: { title: '查看详情', dynamicBgColor: '#ffffff' }
        }
      ],
      meta: {
        title: '对话',
        dynamicBgColor: '#ffffff'
      }
    },
    {
      path: 'home',
      name: 'home',
      component: () => import('@/pages/app/home-page/index.vue'),
      meta: {
        title: '首页',
        homePage: true, // 首页标识，首页标识会有底部导航栏
        showMainHead: false,
        unShowBack: true
      }
    },
    {
      path: 'chat',
      name: 'chat',
      component: () => import('@/pages/app/chat-page/index.vue'),
      meta: {
        title: '对话',
        homePage: true, // 首页标识，首页标识会有底部导航栏
        showMainHead: true,
        unShowBack: true
      }
    },
    {
      path: 'mobile-pk-board',
      name: 'mobilePkBoard',
      component: () => import('@/pages/app/board-page/meeting-board/mobile-pk-board.vue'),
      meta: {
        title: '员工跟进PK'
      }
    },
    {
      path: 'mobile-review-board',
      name: 'mobileReviewBoard',
      component: () => import('@/pages/app/board-page/meeting-board/mobile-review-board.vue'),
      meta: {
        title: '跟进质量复盘'
      }
    },
    {
      path: 'mobile-meeting-review',
      name: 'mobileMeetingReview',
      component: () => import('@/pages/app/board-page/meeting-board/mobile-meeting-review.vue'),
      meta: {
        title: '客户跟进复盘'
      }
    },
    {
      path: 'customer-asset-dashboard',
      name: 'customerAssetDashboard',
      component: () => import('@/pages/app/board-page/customer-asset-dashboard/index.vue'),
      meta: {
        title: '客户资产看板'
      }
    },
    {
      path: 'my',
      name: 'my',
      component: () => import('@/pages/app/my-page/index.vue'),
      meta: {
        title: '我的'
      }
    },
    {
      path: 'visit-path-detail',
      name: 'visit-path-detail',
      component: () => import('@/pages/details/visit-path-detail/index.vue'),
      meta: {
        title: '拜访轨迹'
      }
    },
    {
      path: 'customer-detail',
      name: 'customer-detail',
      component: () => import('@/pages/details/customer-detail/index.vue'),
      meta: {
        title: '客户详情'
      }
    },
    {
      path: 'add-customer',
      name: 'add-customer',
      component: () => import('@/pages/list/add-customer/index.vue'),
      meta: {
        title: '增加标杆客户'
      }
    },
    {
      path: 'mobile-assistant',
      name: 'mobile-assistant',
      component: () => import('@/pages/MobileChatAssistant/index.vue'),
      meta: {
        title: '跟进助手'
      }
    },
    {
      path: 'mobile-xiaobang',
      name: 'mobile-xiaobang',
      component: () => import('@/pages/moblie-xiaobang/index.vue'),
      meta: {
        title: '小邦'
      }
    },
    {
      path: 'mobile-practice-partner',
      name: 'mobile-practice-partner',
      component: () => import('@/pages/MobilePracticePartner/index.vue'),
      meta: {
        title: '陪练助手'
      }
    },
    {
      path: 'mobile-subscribe',
      name: 'mobile-subscribe',
      component: () => import('@/pages/MobileSubscribe/index.vue'),
      meta: {
        title: '定时任务'
      }
    },
    {
      path: 'mobile-schedule-agent',
      name: 'mobile-schedule-agent',
      component: () => import('@/pages/MobileScheduleAgent/index.vue'),
      meta: {
        title: '日程助手'
      }
    }
  ]
}
